import { Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import ThemeContext from "components/app/Context";
import { useContext } from "react";
import { tokens } from "styles/Tokens";
import CloseButton from "./CloseButton";
import "./DialogFormation.scss";
import Typography from "./Typography";

interface Prop {
  openDialog: boolean;
  handleClose: () => void;
  title?: string;
  children?: React.ReactNode;
  actionConfig?: React.ReactNode;
  parentOverflow?: boolean;
  contentClass?: string;
}

export default function DialogFormation(props: Prop) {
  const { isMobileScreen } = useContext(ThemeContext);
  const { openDialog, handleClose, title, actionConfig, children, contentClass = "" } = props;

  return (
    <>
      <Dialog
        fullWidth={true}
        className={`dialogFormation-component`}
        fullScreen={isMobileScreen}
        open={openDialog}
        onClose={(e, r) => {
          if (r !== "backdropClick") handleClose();
        }}
      >
        {title ? (
          <DialogTitle className="dialog-title">
            <div className="title-wrapper">
              <div>
                <Typography color={tokens.Text.General.PrimaryHeadline} showBold variant="h5">
                  {title}
                </Typography>
              </div>
              <div>
                <CloseButton handleClose={handleClose} />
              </div>
            </div>
          </DialogTitle>
        ) : (
          <div className="dialog-title-no-bg ">
            <CloseButton handleClose={handleClose} />
          </div>
        )}
        <DialogContent id="actionItemsDivMobile" className={`dialog-content-wrapper ${contentClass}`}>
          {children}
        </DialogContent>
        {actionConfig && <DialogActions className="dialog-actions">{actionConfig}</DialogActions>}
      </Dialog>
    </>
  );
}
